import { render, staticRenderFns } from "./ReportTabs.vue?vue&type=template&id=596e5817"
import script from "./ReportTabs.js?vue&type=script&lang=js&external"
export * from "./ReportTabs.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports